import { Controller } from '@hotwired/stimulus'
import { removeClass, toggleClass } from 'utils/toggle_class'

export default class extends Controller {
  static targets = ["buttonText", "checkboxItem"]

  initialize() {
    this.updateText()
  }

  toggleDropdown() {
    toggleClass(this.element, "-open")
  }

  closeDropdown() {
    removeClass(this.element, "-open")
  }

  updateText() {
    const selectedItems = this.checkboxItemTargets.filter((checkboxItem) => checkboxItem.checked)

    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.innerHTML = this._buttonText(selectedItems)
    }
  }

  _buttonText(selectedItems) {
    if (selectedItems.length === this.checkboxItemTargets.length) {
      return "All"
    } else if (selectedItems.length === 0) {
      return "Select an item"
    } else if (selectedItems.length === 1) {
      return selectedItems[0].labels[0].textContent.trim()
    } else {
      return `${selectedItems.length} selected`
    }
  }
}
